import { connect } from 'react-redux';

import { openModal } from '../../../helpers/actionCreators/redux';

import ReleasesHeader from './releasesHeader.jsx';

export default connect(null, {
  openModal,
})(ReleasesHeader);
